import { LoaderContext } from '../context';
import { useContext } from 'react';
const useLoader = () => {
  const { setLoading, loading } = useContext(LoaderContext);

  return { setLoading, loading };
};

export default useLoader;
